const capitalize = (word: string | undefined) => word ? (word[0].toUpperCase() + word.slice(1).toLowerCase()) : '';

export default capitalize;
